import { FC, useEffect ,MouseEvent} from "react";
import { useMutation } from "react-query";
import { patientListReportexcelService, patientListReportpdfService, patientListReportService } from "./service";
import { Button, CircularProgress, Paper, TableContainer, Typography } from "@mui/material";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import TableComponent from "../component/TableComponent";
import moment from "moment";
import { clinicId } from "../../constants";
import usePrint from "../../hooks/usePrint";
const PatientReport: FC = () => {
  const { control,reset,handleSubmit,getValues } = useForm();
  const {printPdf}=usePrint()
  const {
    mutate: getPatientReport,
    data: patientData,
    isLoading: patientDataLoading,
    reset:resetMutation
  } = useMutation(patientListReportService);

  const {
    mutate: getPatientReportpdf,
    isLoading: patientDatapdfLoading,
  } = useMutation(patientListReportpdfService,{onSuccess:(data)=>{printPdf(data.response.file)}});

  const {
    mutate: getPatientReportexcel,
    isLoading: patientDataexcelLoading,
  } = useMutation(patientListReportexcelService,{onSuccess:(data)=>{printPdf(data.response,"new-tab","xlsx")}});



  const onSubmit = (data:any)=>{
    getPatientReport({...data,clinicId});
  }

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: ""
    });
    resetMutation()
  }

    const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
      const fileType = e.currentTarget.dataset.filetype;
      const allData = getValues();
      if (fileType === "pdf") {
        getPatientReportpdf({
          fromDate: allData.fromDate,
          toDate: allData.toDate,
          clinicId
        });
      } else {
        getPatientReportexcel({
          fromDate: allData.fromDate,
          toDate: allData.toDate,
          clinicId
        });
      }
    };

    const onChange = ()=>{
      const data = getValues()
      if(data?.fromDate && data?.toDate){
        getPatientReport({ ...data, clinicId });
      }else{
        resetMutation()
      }
    }

  useEffect(() => {
    getPatientReport({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      clinicId
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    })
  }, []);

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
           Patient List Report
          </Typography>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-2 gap-3 p-4">
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required",onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date"}}
            rules={{ required: "To Date is required",onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
         
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
           <Button
                   disabled={ patientDatapdfLoading || !Boolean(patientData?.response?.length)}
                   endIcon={patientDatapdfLoading && <CircularProgress size={18} />}
                   data-filetype="pdf"
                   onClick={getFiles}
                 >
                   pdf
                 </Button>
                 <Button
                   disabled={patientDataexcelLoading || !Boolean(patientData?.response?.length)}
                   endIcon={patientDataexcelLoading && <CircularProgress size={18} />}
                   data-filetype="excel"
                   onClick={getFiles}
                 >
                  download excel
                 </Button>
        </div>
        <TableComponent
          loading={patientDataLoading}
          data={patientData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default PatientReport;
const heading = [
  { heading: "EMR NO/REG NO", key: "emrNo" },
  { heading: "NAME", key: "name" },
  { heading: "GENDER", key: "gender" },
  { heading: "DOCTOR", key: "doctor" },
  { heading: "AGE", key: "age" },
  { heading: "MOBILE NO", key: "mobileNo" },
  { heading: "REGISTERED DATE", key: "foDate" }
];
